import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxAlert } from "../../Limestone/AxAlert/AxAlert";

@ModuleName("ShoppingCartPersonalisation")
export class ShoppingCartPersonalisation implements AxInit {
    AxInit(init: any): void {



    }


}